function shallowEqualObjects(a, b) {
    if (a === b) {
        return true;
    }
    if (!a || !b) {
        return false;
    }
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (!Object.is(a[key], b[key])) {
            return false;
        }
    }
    return true;
}
export default shallowEqualObjects;
